import { ComponentType } from "react";
import MfaqInfoModalContent from "./MfaqInfoModalContent";

type TaskInfoModalContentComponent = ComponentType<{
  visible: boolean;
  onClose: () => void;
}> & { buttonAriaLabelKey: string };

type TaskInfoModalContentsType = Record<string, TaskInfoModalContentComponent>;

const taskInfoModalContents: TaskInfoModalContentsType = {
  "mfaq-follow-up": MfaqInfoModalContent,
};

export type TaskInfoModalContentName = keyof typeof taskInfoModalContents;

export default taskInfoModalContents;
